export enum EAntResultStatus {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning',
  NOT_FOUND = 404,
  NOT_ACCESS = 403,
  SERVER_ERROR = 500,
}
